module.exports = __webpack_public_path__ + "static/media/10stories.5ef22fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10stories.png
// module id = 109
// module chunks = 0